import NotificationsMenu from './NotificationsMenu'

export default NotificationsMenu
// eslint-disable-next-line import/export
export * from './NotificationsMenu'
